<script setup lang="ts">
import { computed } from 'vue'

import type { KanbanComment } from '@entities/kanban-comment'

import { KanbanComments } from '@widgets/kanban-comments'
import { useKanbanCommentsStore } from '@entities/kanban-comment'
import { useOnTimezoneChange } from '@entities/viewer'

import { useDisciplineStore } from '../model/store'
import { parseFilterParams } from '../model/task-comments/filter-params'
import { useDisciplineTaskCommentsApi } from '../api/task-comments/comments.hook'
import { useUpdateDisciplineTaskCommentApi } from '../api/task-comments/update-comment.hook'
import DisciplinePageLoader from './DisciplinePageLoader.vue'

defineOptions({
  name: 'DisciplineTaskCommentsPage',
})

const route = useRoute()
const disciplineId = computed<string>(() => route.params.id as string)

const kanbanCommentsStore = useKanbanCommentsStore()
const disciplineStore = useDisciplineStore()

useOnTimezoneChange(() => {
  const customerId = disciplineStore.getCustomerId
  if (!customerId) return

  const filters = parseFilterParams(route.query)
  const disciplineIdFilter = filters.discipline_id.length
    ? filters.discipline_id
    : [disciplineId.value]

  void useDisciplineTaskCommentsApi({
    customerId,
    disciplineId: disciplineIdFilter,
    createdFrom: filters.created_from,
    createdTo: filters.created_to,
  })
})

const updateCommentApi = (commentId: number, comment: string): Promise<KanbanComment | null> => {
  const existing = kanbanCommentsStore.getComments.find(item => item.id === commentId)
  const taskId = existing?.kanban_task?.id
  if (!taskId) return Promise.resolve(null)
  return useUpdateDisciplineTaskCommentApi({ taskId, commentId, comment })
}
</script>

<template>
  <DisciplinePageLoader />
  <KanbanComments
    title="Task comments"
    additional-data
    :update-api="updateCommentApi"
  />
</template>
